module.exports = __webpack_public_path__ + "static/extra_6-c03ba892b8ccb0b9a311305a52fb191e.jpg";